export const sxStyled = theme => ({
  root: {
    bgcolor: 'rgba(0, 0, 0, 0.1)',
    p: theme.spacing(4, 16),
    position: 'absolute',
    height: '100%',
    [theme.breakpoints.down('lg')]: {
      p: 0,
    },
  },

  container: {
    p: theme.spacing(2),
  },

  header: {
    p: theme.spacing(2),
    bgcolor: theme.headerColor,
  },

  title: {
    fontSize: { xs: '20px', sm: '25px' },
  },

  subtitle: {
    fontSize: { xs: '14px', sm: '18px' },
  },

  inpuLabel: {
    position: 'absolute',
    ml: '10px',
    mt: '-9px',
    bgcolor: '#fff',
    zIndex: 1,
    px: '10px',
  },

  flexEvenly: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
});
